const carTypeForEquipmentExceptNA = ['Straight Truck', 'Tractor & Semi-Trailer', 'Tractor - Two Trailers', 'Tractor - Three Trailers']
const carTypeForEquipmentNA = ['Motorcoach - School Bus (Greater than 8 passengers)', 'Motorcoach - School Bus (Greater than 15 passengers)']
const carTypeForEquipmentAny = ['Other']

const carTypesAll = [...carTypeForEquipmentExceptNA, ...carTypeForEquipmentNA, ...carTypeForEquipmentAny]

const typeOfEquipmentNA = [
  'N/A'
]

const typeOfEquipmentExceptNA = [
  'Van',
  'Reefer',
  'Tank',
  'Flat'
]

const IS_EMPLOYED = {
  EMPLOYED: 'Employed',
  UNEMPLOYED: 'Unemployed',
  NO_ADDITIONAL_EMPLOYMENT: 'I do not have any additional employment or unemployment to report'
}

const isEmployed = Object.values(IS_EMPLOYED)

const typeOfEquipmentAll = [...typeOfEquipmentNA, ...typeOfEquipmentExceptNA]
export default {
  carTypeForEquipmentExceptNA,
  carTypeForEquipmentNA,
  carTypeForEquipmentAny,
  carTypesAll,
  typeOfEquipmentNA,
  typeOfEquipmentExceptNA,
  typeOfEquipmentAll,
  IS_EMPLOYED,
  isEmployed
}
